// Tipos do formulário de cadastro de Fundo Líquido (espelham o agregado do backend).
// Valores numéricos ficam como string no form (inputs) e são convertidos só no envio.

export interface Condicoes {
  tx_adm?: string;
  tx_custodia?: string;
  tx_performance?: string;
  tx_adm_fiduciaria?: string;
  tx_adm_minima?: string;
  valor_minimo_adm_fiduciario?: string;
  vlr_primeira_cota?: string;
  aplicacao_inicial?: string;
  aplicacao_minima?: string;
  saldo_minimo?: string;
  resgate_minimo?: string;
  d_cotizacao_aplic?: string;
  d_cotizacao_resgate?: string;
  d_pgto_resgate?: string;
  taxa_de_saida: boolean;
  taxa_saida_valor?: string;
  saida_antecipada_cotizacao?: string;
  saida_antecipada_pgto?: string;
  vigente_desde?: string;
}

export interface Classe {
  _key: string;
  id?: number;
  // identidade
  subclasse: string;
  nome?: string;
  cnpj_classe?: string;
  tipo_cota?: string;
  condominio?: string;
  publico_alvo?: string;
  status_aplicacao?: string;
  calendario?: string;
  // mercado
  cod_cetip?: string;
  isin?: string;
  benchmark?: string;
  spread?: string;
  rating?: string;
  razao_garantia?: string;
  razao_garantia_target?: string;
  // flags
  divulgacao_site: boolean;
  is_active: boolean;
  dt_inicio?: string;
  dt_encerramento?: string;
  // condições
  condicoes: Condicoes;
}

export interface Conta {
  _key: string;
  id?: number;
  tipo: string;
  codigo?: string;
  banco?: string;
  agencia?: string;
  numero_conta?: string;
  favorecido?: string;
}

export interface VinculoPrestador {
  _key: string;
  id?: number;
  prestador_id?: number;
  prestador_nome?: string; // só p/ exibição (nome do prestador escolhido)
  papel: string;
  data_inicio?: string;
  data_fim?: string;
}

export interface DocumentoVersao {
  numero_versao: number;
  nome_arquivo: string;
  data_referencia?: string; // data do envio
  tamanho?: string;         // ex.: "1,2 MB"
  is_current: boolean;
}

export interface DocumentoAnexo {
  tipo: string;            // REGULAMENTO, CONTRATO_ADMINISTRADOR, ...
  documento_id?: number;
  nome_arquivo?: string;   // nome do arquivo importado (versão atual)
  titulo?: string;         // = tipo (preenchido automaticamente)
  data_referencia?: string; // default: data da importação
  versoes?: DocumentoVersao[]; // histórico (documento_versao); só no detalhe
  _file?: File;            // arquivo real selecionado (transient, p/ upload ao S3)
}

export interface FundoForm {
  cnpj: string;
  razao_social: string;
  nome_fantasia?: string;

  forma_juridica?: string;
  moeda: string;
  master_fic?: string;
  codigo_anbima?: string;
  data_lancamento?: string;
  data_encerramento?: string;
  voice?: string;
  juros?: string;
  observacao?: string;
  is_active: boolean;
  count_on_aum: boolean;
  gera_lamina: boolean;
  paga_gestao: boolean;

  classe_anbima_n1?: string;
  classe_anbima_n2?: string;
  classe_anbima_n3?: string;
  classe_anga_1?: string;
  classe_anga_2?: string;

  classes: Classe[];
  contas: Conta[];
  prestadores: VinculoPrestador[];
  documentos: DocumentoAnexo[];
}

export const condicoesVazia = (): Condicoes => ({ taxa_de_saida: false });

export const classeVazia = (key: string): Classe => ({
  _key: key,
  subclasse: 'Única',
  divulgacao_site: false,
  is_active: true,
  condicoes: condicoesVazia(),
});

export const contaVazia = (key: string): Conta => ({ _key: key, tipo: '' });

export const prestadorVazio = (key: string): VinculoPrestador => ({
  _key: key,
  papel: '',
  data_inicio: new Date().toISOString().slice(0, 10), // default: hoje (editável)
});
